import { CURRENCY, LOCALE } from "@constants/index";
export var formatDate = function (date) {
    return date.toLocaleDateString(LOCALE);
};
export var formatPrice = function (price, currency) {
    if (currency === void 0) { currency = true; }
    var formatedPrice = price.toFixed(2);
    if (currency) {
        return formatedPrice + " " + CURRENCY;
    }
    return formatedPrice;
};
export var formatPriceRange = function (from, to) {
    if (from === undefined || to === undefined) {
        return "";
    }
    if (from === to) {
        return formatPrice(from);
    }
    return formatPrice(from, false) + " - " + formatPrice(to);
};
